<template>
  <n-tooltip trigger="hover" placement="right" v-if="isSubsMissing">
    <template #trigger>
      <n-float-button right="20" type="primary" bottom="80" shape="circle" @click="goToShop"  color="red">
        <n-badge dot :offset="[4, -4]" value="!">
          <n-icon>
            <BuyIcon/>
          </n-icon>
        </n-badge>
      </n-float-button>
    </template>
      The account is not fully set up yet and requires payment to be finalized!
  </n-tooltip>
</template>

<script setup lang="ts">
import {computed} from "vue"
import {renderIcon} from "@/utils"
import {NBadge, NFloatButton, NTooltip, NIcon} from "naive-ui"
import {useAuthStore} from "@/stores/auth"

const authStore = useAuthStore()
const isSubsMissing = computed(() => authStore.getSubscriptionIsRequired())
const BuyIcon = renderIcon("carbon:shopping-cart")


async function goToShop() {
  if (!authStore.getSubscriptionIsRequired()) return

  const missingSubs = authStore.getMissingSubscriptions()[0]?.[0]
  if (!missingSubs) return

  const paymentUrl = await authStore.fetchPaymentUrl(missingSubs)
  if (!paymentUrl || paymentUrl.length < 4) return

  window.open(paymentUrl, "_blank")
}

</script>
